const menu = [
  {
    href: "#header",
    name: "Inicio"
  },
  {
    href: "#about",
    name: "Sobre"
  },
  {
    href: "#courses",
    name: "Qualificações"
  },
  {
    href: "#projects",
    name: "Projetos"
  },
  {
    href: "#footer",
    name: "Contatos"
  }
]


export default menu